import '../App.css';
import React from 'react';
function VideoPlayer(props){
    return(
        <div className="responsive-video-container">
            <video key={props.key} id={props.id} className="responsive-video" preload="metadata" controls>
                <source src={props.value} type="video/mp4" />
            </video>
            <p><span><a href={props.value}>{props.value}</a></span></p>
        </div>
    );
}

export default VideoPlayer;